import SV from 'server-vars';
import { sessionStorage } from 'dibs-browser-storage';
import { getEverLoggedIn, getBuyerId } from 'dibs-cookie-jar';
import { PAGE_TYPE, BROWSE_TYPES } from '../../utils/pageConstants';
import { VisitCountModel } from 'dibs-visit-tracking/exports/visitCountModel';
import authModalLoader from '../../utils/AuthModalLoader';
import * as postAuthLoader from './helpers/postAuthLoader';
import isPageType from '../../utils/isPageType';
import { isPlaReferrer } from './helpers/referrerHelper';

const isAllowedPageType = () => {
    const isPdpPrintPage = SV.get('settings.isPrintPDP');
    const allowedPageTypes = [PAGE_TYPE.HOME, PAGE_TYPE.CREATOR, PAGE_TYPE.DEALER, PAGE_TYPE.PDP];

    const isAllowedPage = isPageType([...allowedPageTypes, ...BROWSE_TYPES]);

    return isAllowedPage && !isPdpPrintPage;
};

/**
 * should visitor be prompted to login?
 * @returns {boolean}
 */
const isBlocked = function isBlocked() {
    const searchParams = new URLSearchParams(location.search);
    const loggedIn = getBuyerId(document.cookie);
    if (loggedIn || searchParams.has('modal') || !isAllowedPageType() || isPlaReferrer()) {
        return true;
    }
    return false;
};

const shouldPromptLoginRegistration = visitCountModel => {
    return visitCountModel.get('session') === visitCountModel.get('regPromptLimit');
};

const canAutoPromptUser = () => {
    const visitCountModel = new VisitCountModel();
    const isModalBlocked = isBlocked();
    const shouldOpenModal = shouldPromptLoginRegistration(visitCountModel);
    if (shouldOpenModal && !isModalBlocked) {
        return true;
    } else if (shouldOpenModal && isModalBlocked) {
        visitCountModel.increment('regPromptLimit');
        visitCountModel.save();
        return false;
    } else {
        return false;
    }
};

const getActionAndFlow = () => {
    let action = authModalLoader.constants.REGISTER;
    let flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
    const ga = {};
    const everLoggedIn = getEverLoggedIn(document.cookie);
    if (everLoggedIn) {
        action = authModalLoader.constants.LOGIN;
        flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
        if (everLoggedIn.toLowerCase() === 'trade') {
            flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
            ga.label = 'pageview limit reached - trade';
        }
    }

    return { action, flow, ga };
};

/**
 * prompts visitor to register if it's due
 * @return {boolean} true if login prompted
 */
const openLoginModal = () => dispatch => {
    const { action, flow, ga } = getActionAndFlow();

    sessionStorage.setItem('authModalShown', true);

    if (
        action === authModalLoader.constants.REGISTER &&
        flow === authModalLoader.constants.PAGEVIEW_LIMIT_FLOW
    ) {
        postAuthLoader.autoPromptRegistration({ flow });
    } else {
        authModalLoader.show({
            action: action,
            flow: flow,
            ga: Object.assign(
                {
                    label: 'pageview limit reached',
                },
                ga
            ),
        });
    }
    dispatch({ type: 'noop' });
};

/**
 * Checks condition for auto prompt user.
 * Opens modal if condition is satisfied.
 * Condition:
 * page view >= 3,
 * home / browse / creator / pdp (not print) page type,
 * User is not logged in and AuthModal is not opened.
 *
 * @return {Promise}
 */
const loginPromptRule = function loginPromptRule() {
    if (canAutoPromptUser()) {
        return Promise.resolve(true);
    }
    return Promise.resolve(false);
};

export default {
    name: 'loginPrompt',
    rule: loginPromptRule,
    action: openLoginModal,
    priority: 250,
};
